(ns ui.ui
  "Some very generic UI parts like the not-found-page.")

(defn render-page [_state]
  [:h1 "Not found"])
